
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class TipologieRisorseDialog extends Serenity.EntityDialog<TipologieRisorseRow, any> {
        protected getFormKey() { return TipologieRisorseForm.formKey; }
        protected getIdProperty() { return TipologieRisorseRow.idProperty; }
        protected getLocalTextPrefix() { return TipologieRisorseRow.localTextPrefix; }
        protected getNameProperty() { return TipologieRisorseRow.nameProperty; }
        protected getService() { return TipologieRisorseService.baseUrl; }
        protected getDeletePermission() { return TipologieRisorseRow.deletePermission; }
        protected getInsertPermission() { return TipologieRisorseRow.insertPermission; }
        protected getUpdatePermission() { return TipologieRisorseRow.updatePermission; }

        protected form = new TipologieRisorseForm(this.idPrefix);

    }
}